import {FC} from "react";
import {
    IconButton,
    Tooltip,
} from "@mui/material";
import {List} from "@mui/icons-material";
import {Locale} from "../../../locales/Locale";
import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";

interface IDetailsButton {
    handleDetailsClick?: () => void;
    value?: any;
}

// TODO move out as generic
export const DetailsButton: FC<IDetailsButton> = ({handleDetailsClick}) => {
    return (
        <Tooltip title={<Locale localeId={IdlocaGeneric.view_details}/>}>
            <IconButton
                aria-label="details"
                onClick={handleDetailsClick}
                size="small"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50px",
                    width: "50px",
                }}
            >
                <List/>
            </IconButton>
        </Tooltip>
    );
};
